module.exports = __webpack_public_path__ + "img/exam_jan_2025_v5toudz8.976268d7.jpg";